module.exports = __webpack_public_path__ + "static/media/lineBreak.e9de2292.svg";